
  document.addEventListener('DOMContentLoaded', () => {

  const wrappers = document.querySelectorAll('.custom-color-swatches');

  wrappers.forEach((wrapper) => {

    const blockId = wrapper.dataset.blockId;

    const parent = wrapper.closest('.card-scroll-product');

    if (!parent) return;

    // GET ALL ELEMENTS
    const titles = parent.querySelectorAll(`.js-product-title[data-block-id="${blockId}"]`);

    const prices = parent.querySelectorAll(`.js-product-price[data-block-id="${blockId}"]`);

    const variantInputs = parent.querySelectorAll(`.js-product-variant-id[data-block-id="${blockId}"]`);

    const productImages = parent.querySelectorAll(`.js-product-image[data-block-id="${blockId}"]`);

    const swatches = wrapper.querySelectorAll('.custom-color-swatch');

    if (!swatches.length) return;

    swatches[0].classList.add('active');

    swatches.forEach((swatch) => {

      swatch.addEventListener('click', () => {

        swatches.forEach((item) => {
          item.classList.remove('active');
        });

        swatch.classList.add('active');

        // UPDATE ALL TITLES
        titles.forEach((title) => {
          title.innerHTML = swatch.dataset.title;
        });

        // UPDATE ALL PRICES
        prices.forEach((price) => {
          price.innerHTML = swatch.dataset.price;
        });

        // UPDATE ALL VARIANT IDS
        variantInputs.forEach((input) => {
          input.value = swatch.dataset.variantId;
        });

        // UPDATE ALL IMAGES
        productImages.forEach((image) => {
          image.src = swatch.dataset.productImage;
        });

      });

    });

  });

});

document.addEventListener("DOMContentLoaded", () => {

  const cards = document.querySelectorAll(".card-scroll-product-bg");

  const animateCards = () => {

    cards.forEach((card, index) => {

      const rect = card.getBoundingClientRect();

      const windowHeight = window.innerHeight;

      const progress = Math.min(
        Math.max((windowHeight - rect.top) / windowHeight, 0),
        1
      );

      // Smooth scale only
      const scale = 1 - (index * 0.03) + (progress * 0.03);

  
      card.style.zIndex = 100 + index;

    });

    requestAnimationFrame(animateCards);

  };

  animateCards();

});